import React, { useContext } from "react";
import { EstadoVistaColaborador } from "../../../../../../../../../enum/EstadoVistaColaborador";
import { FileSearchOutlined, UserOutlined } from "@ant-design/icons";
import { SecurityContext } from "context/SecurityContextProvider";

export function ColumnaDocumento({ fila }) {
	const { getUsuarioAutenticado } = useContext(SecurityContext);
	const isPSP = getUsuarioAutenticado().empresaSeleccionada?.ruc === "20601257280" ? true : false;
	const estilo = {
		documentoBloqueado: {
			color: "#979393",
		},
		documentoPendiente: {
			// color: "#f1746d"
			color: "#faad14",
		},
		documentoRechazado: {
			color: "#f57d76",
		},
		documentoVisualizado: {
			color: "#3bb937",
		},
		periodo: {
			display: "block",
			fontWeight: "bold",
			color: "rgba(0, 0, 0, 0.65)",
		},
		nombreDocumento: {
			display: "block",
		},
		colaborador: {
			display: "flex",
			alignItems: "center",
			gap: "4px",
			marginTop: "4px",
			fontSize: "12px",
			color: "#1890ff",
			fontStyle: "italic",
		},
		documentoPendienteAprobacion: {
			color: "#1890ff",
		},
	};

	const estiloEstadoImagen = () => {
		if (
			fila.estadoAprobacion != null &&
			fila.estadoAprobacion === "PENDIENTE" &&
			fila.estadoVistaColaborador === "FIRMADO"
		) {
			return estilo.documentoPendienteAprobacion;
		} else if (
			fila.estadoAprobacion != null &&
			fila.estadoAprobacion === "RECHAZADO" &&
			fila.estadoVistaColaborador === EstadoVistaColaborador.FIRMADO
		) {
			return estilo.documentoRechazado;
		} else if (
			fila.estadoVistaColaborador === EstadoVistaColaborador.PENDIENTE &&
			fila.permitirVisualizarDocumento === true
		) {
			return estilo.documentoPendiente;
		} else if (
			fila.estadoVistaColaborador === EstadoVistaColaborador.PENDIENTE &&
			fila.permitirVisualizarDocumento === false
		) {
			return estilo.documentoBloqueado;
		} else {
			return estilo.documentoVisualizado;
		}
	};

	return (
		<div className="documentos__item-documento">
			<div className="imagen">
				<FileSearchOutlined style={estiloEstadoImagen()} />
			</div>
			<div className="descripcion">
				<span style={estilo.periodo}>{fila.periodo}</span>
				<span style={estilo.nombreDocumento}>{fila.nombreDocumento}</span>
				{isPSP && fila.tareaPendienteId && fila.colaboradorNombre && (
					<span style={estilo.colaborador}>
						<UserOutlined />
						{fila.colaboradorNombre}
						{fila.colaboradorNumeroDocumento && ` · Doc: ${fila.colaboradorNumeroDocumento}`}
					</span>
				)}
			</div>
		</div>
	);
}
